import React from 'react';
import PropTypes from 'prop-types';

import pageStyles from '../../containers/StewardAssetEditPage/StewardAssetEditPage.scss';

const propTypes = {
  label: PropTypes.string,
  field: PropTypes.string,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  validation: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  size: PropTypes.number,
  onChange: PropTypes.func.isRequired
};

const defaultProps = {
  value: '',
  size: null,
  validation: []
};


export default class SelectInput extends React.PureComponent {
  componentDidUpdate(){
    const {options, value, onChange, field} = this.props;
    if (!value && options.length === 1) {
      onChange({target: {dataset: {field}, value: options[0].value} })
    }
  }

  render() {
    const id = `mod_${this.props.field.replace('.', '_')}`;
    const label = !this.props.label ? null : (
      <label htmlFor={id}>{this.props.label}</label>
    );
    const validation = !this.props.validation ? null : (
      <ul>{this.props.validation.map((err) => (
        <li key={err}>{err}</li>
      ))}
      </ul>
    );
    const validationCSS = this.props.validation.length > 0 ? pageStyles["validation-problems"] : "";
    const requiredCSS = this.props.required ? pageStyles.required : "";
    const fullWidthCSS = this.props.fullWidth ? pageStyles["full-width"] : "";
    const css = `${pageStyles["text-input"]} ${requiredCSS} ${fullWidthCSS} ${validationCSS}`;
    const {value, field, size, onChange} = this.props;
    return (
      <div className={css}>
        {label}
        <select data-field={field} name={this.props.field} value={value} onChange={onChange} size={size}>
          {this.props.options.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
        {validation}
      </div>
    );
  }
}

SelectInput.propTypes = propTypes;
SelectInput.defaultProps = defaultProps;
